import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@noda-lib/utils/injection';
import { PlatformService } from '@noda-lib/utils/services';
import { NODA_LIVE, NODA_WEB_LINK } from '@shared/constants/noda-links';

@Injectable({
  providedIn: 'root',
})
export class LinkService {
  private window: Window = inject(WINDOW);
  private platformService: PlatformService = inject(PlatformService);

  public addQueryParams(url: string): string {
    if (this.platformService.isServer()) {
      return '';
    }

    const urlParamsPart: string[] = url.split('?');
    const params: URLSearchParams = new URLSearchParams(urlParamsPart[1]);
    const searchParams: URLSearchParams = new URLSearchParams(this.window.location.search);

    searchParams.forEach((value: string, key: string) => {
      params.append(key, value);
    });

    return params.toString() ? urlParamsPart[0] + '?' + params.toString() : urlParamsPart[0];
  }

  public getQueryParams(): string {
    if (this.platformService.isServer()) {
      return '';
    }

    return this.window.location.search || '';
  }

  public replaceLinkWithTag(content: string): string | undefined {
    const linkRegex: RegExp = /<a\s+([^>]*?)href="([^"]+)"([^>]*)>(.*?)<\/a>/gi;
    const replacer: (
      match: string,
      beforeHref: string,
      href: string,
      afterHref: string,
      innerText: string,
    ) => string = (
      match: string,
      beforeHref: string,
      href: string,
      afterHref: string,
      innerText: string,
    ) => {
      const attributes: string = `${beforeHref.trim()} ${afterHref.trim()}`.trim();

      return this.createLink(match, href, attributes, innerText);
    };

    return content?.replace(linkRegex, replacer);
  }

  private createLinkTag(href: string, attributes: string, innerText: string): string {
    return `<a href="${href}" ${attributes}>${innerText}</a>`;
  }

  private createInnerLinkTag(href: string, attributes: string, innerText: string): string {
    return this.createLinkTag(href, attributes.replace('rel="nofollow"', ''), innerText);
  }

  private createLink(match: string, href: string, attributes: string, innerText: string): string {
    switch (true) {
      case match.includes(NODA_WEB_LINK):
        return this.createInnerLinkTag(
          href.replace(NODA_WEB_LINK, '') + this.getQueryParams(),
          attributes,
          innerText,
        );

      case match.includes(NODA_LIVE) || href.startsWith('/'):
        return this.createInnerLinkTag(href + this.getQueryParams(), attributes, innerText);

      default:
        return this.createLinkTag(href, `${attributes} target="_blank" rel="nofollow"`, innerText);
    }
  }
}
